module.exports = __webpack_public_path__ + "img/00—Open Source.db8c86c1.jpg";